import { formatRelativeTime } from '../../DueDateDisplay/utils/formatRelativeTime';
import { REMINDER_TRIGGER } from '../../../../../../utils/missionReminders';
import { formatRecurringEnd, formatRecurringLabel } from '../../../../../../utils/recurringSchedule';

export function chipLabel(reminder) {
  if (reminder.forStart) return 'Time to start';
  if (reminder.trigger === REMINDER_TRIGGER.WHEN_AVAILABLE) return 'When available';
  if (reminder.recur) return formatRecurringLabel(reminder.recur);
  return formatRelativeTime(reminder.at) || 'At a time';
}

export function chipTitle(reminder) {
  const label = chipLabel(reminder);
  if (!reminder.recur) return reminder.note ? `${label} — ${reminder.note}` : label;
  return [label, formatRecurringEnd(reminder.recur), reminder.note].filter(Boolean).join(' — ');
}

export function formatStartWhen(value) {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function hasInstant(reminders, iso) {
  const at = Date.parse(iso);
  if (!Number.isFinite(at)) return false;
  return reminders.some((reminder) => (
    reminder.trigger === REMINDER_TRIGGER.AT_TIME && Date.parse(reminder.at) === at
  ));
}
